<template>
    <PageView>
            <a-modal v-model="modalVisible" title="编辑" :ok-text="modalEditMode ? '保存' : '确定'" @ok="handleOk">
                  <a-form ref="form" :model="formData">
                    <a-form-item label="" :label-col="labelCol" :wrapper-col="wrapperCol">
                                <span> <span style="color:red">*</span> 选择问题分类:</span>
                                <a-select allowClear style="width:100%" placeholder="请问题分类" v-model="formData.category_id" >
                                    <a-select-option :value="value.id" v-for="(value, key) in selectList" :key="key">
                                        {{ value.name }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="标题">
                                <a-input v-model="formData.title"></a-input>
                            </a-form-item>
                    <p>内容:</p>
                    <a-textarea v-model="formData.content" placeholder="请输入内容" allow-clear />
                  </a-form>
                </a-modal>

        <a-card title="列表">
            <a-button type="primary" slot="extra" @click="showModal">添加</a-button>
            <a-table :columns="columns" :data-source="dataSource">
            <template #content="{ text }">
                <div class="ellipsis">{{ text }}</div>
            </template>
            </a-table>
        </a-card>
       
    </PageView>
</template>

<script>
//  // type 类型 1输入框 2图片 3富文本
import Problem from "../../api/problem.js"
import { clearData } from '../../api/login'
import Config from '../../api/Config.js'
import Home from '../../api/Home.js'
import editor from '@tinymce/tinymce-vue'
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image' // 插入上传图片插件
import 'tinymce/plugins/media' // 插入视频插件
import 'tinymce/plugins/code'
import 'tinymce/plugins/link'
import '../../../public/tinymce/axupimgs'
export default {
    name: 'index',
    components: {
        editor
    },
    data() {
        return {
            modalVisible: false,
            modalEditMode: false,
            formData: {
                content:'',
                title:'',
                category_id: ''
            },
            selectContent:'',
            dataSource: [],
            columns: [
        {
          title: '标题',
          dataIndex: 'title',
          width: '25%',
          key: 'title',
          customRender: (text) => {
            return <div class="ellipsis">{text}</div>
          }
        },
        {
          title: '内容',
          dataIndex: 'cont',
          width:'50%',
          key: 'content',
          customRender: (text) => {
            return <div class="ellipsis">{text}</div>
          }
        },
        {
          title: '操作',
          key: 'action',
          width: '25%',
          customRender: (scope) => {
            return (
              <div>
                <a-button type="primary" onClick={() => this.editItem(scope)}>编辑</a-button>
                <a-divider type="vertical"></a-divider>
                <a-button type="danger" onClick={() => this.deleteItem(scope)}>删除</a-button>
              </div>
            );
          }
        }
      ],


            form: this.$form.createForm(this),
            loading: true,
            visible: false,
            viewImg: {},
            type: 1,
            pdf: '',
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 }
            },
            inputArray: [],
            pageSize: 10,
            current: 1,
            init: {
                language_url: `../../tinymce/langs/zh_CN.js`, //语言包的路径
                language: 'zh_CN', //语言
                skin_url: `../../tinymce/skins/ui/oxide`, //skin路径
                height: 500, //编辑器高度
                branding: false, //是否禁用“Powered by TinyMCE”
                menubar: false, //顶部菜单栏显示
                plugins: 'image axupimgs media',
                images_upload_handler: (blobInfo, success, failure) => {
                    this.handleImgUpload(blobInfo, success, failure)
                },
                // toolbar:
                    // 'axupimgs | undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists  media table | removeformat'
                toolbar:
                    'undo redo |  formatselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat'
            },
            showSizeChanger: true,
            data: [],
            content: '',
            saveContent: false,
            btnloading: false,
            id: '',
            pic: '',
            total: 10,
            selectList:[],
        }
    },
    activated () {
        this.getList()
    },
    methods: {
        
        getList(){
            Problem.categoryList().then(res => {
                this.selectList = res.result;
            })
            Problem.problemList({
                page: this.current,
                num: this.pageSize,
            }).then(res => {
                this.dataSource = res.result;
            })
        },
        showModal() {
            this.modalEditMode = false;
            this.modalVisible = true;
            this.$nextTick(()=>{
                this.formData.content= '';
                this.formData.title= '';
                this.formData.category_id= '';
            })
            
        },
        handleOk() {
                if (this.modalEditMode) {
                    // 编辑模式
                    // TODO：更新数据
                    console.log('更新')
                    Problem.SaveProblem({
                            id:this.listId,
                            category_id:this.formData.category_id , 
                            cont:this.formData.content , 
                            title:this.formData.title
                        }).then(res => {
                            this.getList();
                            
                        }).catch(res => {

                        })
                    this.modalVisible = false;
                } else {
                    // 添加模式
                    // TODO：保存数据
                    Problem.AddProblem({category_id:this.formData.category_id , cont:this.formData.content , title:this.formData.title}).then(res => {
                            this.getList();
                            
                        }).catch(res => {

                        })
                    this.modalVisible = false;
                }
            
        },
        editItem(item) {
            this.modalEditMode = true;
            this.modalVisible = true;
            // TODO：回显数据到表单
            this.listId = item.id;
            this.formData.category_id = item.category_id;
            this.formData.title = item.title;
            this.formData.content = item.cont;
        },
        deleteItem(item) {
            // TODO：删除数据
            console.log('item',item)
            Problem.deleteProblem({id:item.id
            }).then(res => {
                this.getList()
            })
        },




    }
}
</script>

<style scoped lang="less">
.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;

    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}

.imgContaienr {
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 15px;

    .con {
        height: 300px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            display: block;
            max-height: 100%;
            max-width: 100%;
        }

        .placeText {
            font-size: 20px;
        }
    }
}

.editCon {
    margin-bottom: 20px;
    position: relative;

    .editCon {
        position: absolute;
        z-index: 1;
        top: 3px;
        right: 5px;
    }
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>